import {
  getUserRequests,
  getUsers,
  postUser,
  putUser,
  putUserRequest,
} from "../../api";
import { createSliceWithThunks } from "../utils";

const initialState = {
  activeSession: localStorage.getItem("activeSession")
    ? JSON.parse(localStorage.getItem("activeSession"))
    : null,
  post: {
    data: null,
    status: "idle",
    error: null,
  },
  put: {
    data: null,
    status: "idle",
    error: null,
  },
  get: {
    list: [],
    status: "idle",
    error: null,
  },
  requests: {
    list: [],
    status: "idle",
    error: null,
  },
  putRequests: {
    data: null,
    status: "idle",
    error: null,
  },
};

export const authSlice = createSliceWithThunks({
  name: "users",
  initialState: initialState,
  reducers: (create) => ({
    resetStateUsers: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),
    //* thunks
    fetchUsers: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getUsers(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.get.status = "loading";
        },
        rejected: (state, action) => {
          state.get.status = "failed";
          state.get.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.get.error = { message: respObj };
            } else if (status === "success") {
              state.get.list = respObj;
              state.get.error = null;
            }
          } else {
            state.get.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.get.status = "idle";
        },
      }
    ),
    addUser: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postUser(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.post.status = "loading";
        },
        rejected: (state, action) => {
          state.post.status = "failed";
          state.post.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200 || status === 201) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.post.error = { message: respObj };
            } else if (status === "success") {
              state.post.data = respObj;
              state.post.error = null;
            }
          } else {
            state.post.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.post.status = "idle";
        },
      }
    ),
    updateUser: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await putUser(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.put.status = "loading";
        },
        rejected: (state, action) => {
          state.put.status = "failed";
          state.put.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200 || status === 201) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.put.error = { message: respObj };
            } else if (status === "success") {
              state.put.data = respObj;
              state.put.error = null;
            }
          } else {
            state.put.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.put.status = "idle";
        },
      }
    ),
    fetchUserRequests: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getUserRequests(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.requests.status = "loading";
        },
        rejected: (state, action) => {
          state.requests.status = "failed";
          state.requests.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.requests.error = { message: respObj };
            } else if (status === "success") {
              state.requests.list = respObj;
              state.requests.error = null;
            }
          } else {
            state.requests.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.requests.status = "idle";
        },
      }
    ),
    updateUserRequest: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await putUserRequest(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.putRequests.status = "loading";
        },
        rejected: (state, action) => {
          state.putRequests.status = "failed";
          state.putRequests.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200 || status === 201) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.putRequests.error = { message: respObj };
            } else if (status === "success") {
              state.putRequests.data = respObj;
              state.putRequests.error = null;
            }
          } else {
            state.putRequests.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.putRequests.status = "idle";
        },
      }
    ),
  }),
});

export const {
  resetStateUsers,
  addUser,
  fetchUsers,
  updateUser,
  fetchUserRequests,
  updateUserRequest,
} = authSlice.actions;
export default authSlice.reducer;
